import {useContext} from 'react';
import {ToastContext} from '../ToastContext';

export const useShowToast = () => useContext(ToastContext).showToast;
export const useRemoveAllToasts = () =>
  useContext(ToastContext).removeAllToasts;
